import { sendGA4Event } from './google_analytics';
import { mixpanelEvent } from './mixpanel';

export function sendAnalytics(eventData) {
    if (!eventData || Object.keys(eventData).length === 0) {
        console.warn('Invalid Event Data');
        return;
    }

    const { vendor = [] } = eventData || {};

    const isVendorExist = Array.isArray(vendor)
        ? vendor.length > 0
        : false;

    const callVendorEvents = (vendor, eventData) => {
        switch (vendor) {
            case 'ga':
                sendGA4Event(eventData);
                break;
            case 'mixpanel':
                mixpanelEvent(eventData);
                break;
            default:
                console.warn('Invalid vendor type:', vendor);
                break;
        }
    };

    if (isVendorExist) {
        vendor.forEach((vendor) => {
            callVendorEvents(vendor,eventData);
        });
        return;
    }
}